module.exports = __webpack_public_path__ + "img/menu_grid_original.4eab5752.svg";